<template>
    <div class="d-flex flex-column ga-2">
        <div class="text-h6 font-weight-bold">Rechercher un participant</div>
        <div class="d-flex ga-2">
            <v-text-field label="Entrez l'adresse mail du participant" prepend-icon="mdi-magnify" density="compact"
                v-model="mail" @keyup.enter="searchParticipant" hide-details></v-text-field>
            <SportipsButton icon="mdi-magnify" @click="searchParticipant" :disabled="mail.length === 0">
                Rechercher
            </SportipsButton>
        </div>
        <v-alert v-if="has_launched_search && !has_results" density="compact" border="start" border-color="red">Aucun
            participant
            trouvé pour cette adresse mail '{{ mail }}'</v-alert>

        <v-row v-if="has_results">
            <v-col cols="12" md="4" v-for="result in results" :key="result.id">
                <div class="spo-card pa-2 rounded d-flex flex-column ga-1 bordered">
                    <div>
                        <v-chip color="darkblue" variant="elevated" elevation="0">
                            <span class="text-h6">
                                Position n°{{ result.position }}
                            </span>
                        </v-chip>
                    </div>
                    <div>Mail: <b>{{ result.mail }}</b></div>
                    <div>Course: <b>{{ getCourseName(result.id_course) }}</b></div>
                    <div class="text-subtitle-1">Entré en liste d'attente le {{
                        $moment(result.created_at).format("DD/MM/YYYY à HH:mm")
                    }}
                    </div>
                    <div>
                        <SportipsButton icon="mdi-delete" @click="deleteFromListeAttente(result.id)">
                            Supprimer de la liste d'attente
                        </SportipsButton>
                    </div>

                </div>
            </v-col>
        </v-row>

        <!-- Modale de confirmation de suppression -->
        <v-dialog v-model="show_confirm_delete" width="500" max-width="100%" scroll-strategy="none">
            <v-card>
                <v-card-title>
                    <div class="text-h6 font-weight-bold">Confirmation de suppression</div>
                </v-card-title>
                <v-card-text>
                    <div class="text-body-1">Voulez-vous vraiment <b>supprimer</b> ce participant de la liste d'attente
                        ?</div>
                    <div v-if="participant_to_delete">
                        <div class="mt-3">
                            <div>Mail: <b>{{ participant_to_delete.mail }}</b></div>
                            <div>Course: <b>{{ getCourseName(participant_to_delete.id_course) }}</b></div>
                            <div>Position: <b>n°{{ participant_to_delete.position }}</b></div>
                        </div>
                    </div>
                    <div class="mt-2 text-caption">Cette action est irréversible.</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" variant="text" @click="show_confirm_delete = false">Annuler</v-btn>
                    <v-btn color="red-darken-4" variant="elevated" @click="confirmDelete">Supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>


<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import AdminService from "@/services/admin.service";
export default {
    name: 'ListeAttenteBourseSearchForm',
    data() {
        return {
            mail: "",
            results: [],
            show_confirm_delete: false,
            participant_to_delete: null,
            has_launched_search: false,
        }
    },
    computed: {
        ...mapStores(useMainStore),
        has_search_terms() {
            return this.mail.length > 0;
        },
        has_results() {
            return this.results.length > 0;
        }
    },
    watch: {
        mail(newVal) {
            this.has_launched_search = false;
            // Réinitialiser les résultats si le champ est vidé
            if (newVal.length === 0) {
                this.results = [];
            }

        }
    },
    methods: {
        getCourseName(id_course) {
            if (id_course == '' || id_course == null || id_course == "0") return 'Non sportif';
            return this.mainStore.module.courses.list.find(course => course.id == id_course).nom;
        },
        async searchParticipant() {
            this.has_launched_search = true;
            const id_module = this.mainStore.module.id;
            let request = await AdminService.searchListeAttenteParticipant(this.mail, id_module);
            if (!request) {
                this.results = [];
            }
            this.results = request;
        },
        deleteFromListeAttente(id) {
            const participant = this.results.find(r => r.id == id);
            if (participant) {
                this.participant_to_delete = participant;
                this.show_confirm_delete = true;
            }
        },
        async confirmDelete() {
            if (!this.participant_to_delete) return;

            const request = await AdminService.deleteFromListeAttenteBourse(this.participant_to_delete.id);

            if (request) {
                this.mainStore.notification.send("Participant supprimé de la liste d'attente avec succès", "success");
                // Rafraîchir les résultats
                await this.searchParticipant();
                // Émettre un événement pour rafraîchir l'overview
                this.$emit('refresh');
            } else {
                this.mainStore.notification.send("Erreur lors de la suppression du participant", "error");
            }

            this.show_confirm_delete = false;
            this.participant_to_delete = null;
        }
    }
}
</script>

<style lang="scss" scoped></style>